import { Stack, Typography } from '@mui/material';

type ModulCardLabelValueProps = {
  readonly label: string;
  readonly value: string | null;
};

export const ModulCardLabelValue = ({ label, value }: ModulCardLabelValueProps) => {
  if (value === null) {
    return null;
  }

  return (
    <Stack direction="column" spacing={0.5}>
      <Typography variant="labelSmLight" color="textTertiary">
        {label}
      </Typography>
      <Typography variant="labelMultilineLight">{value}</Typography>
    </Stack>
  );
};
